export default {
  id: 'teams_promote_jobs',
  title: 'Promote jobs',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_JOBS' ],
  description: 'Send up to 4 selected jobs to your employees so they can easily share them across their network.',
  body: {
    attachments: [],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_JOB>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_JOB: id => `<attachment id='${id}'></attachment>`,
  },
  attachment(id, jobShareType = 'default') {
    let content = {};
    const generateContent = (items) => ({
      type: 'AdaptiveCard',
      version: '1.5',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      body: [
        {
          type: 'Container',
          separator: true,
          items: [
            {
              type: 'ColumnSet',
              columns: [
                {
                  type: 'Column',
                  width: 'stretch',
                  items: [
                    {
                      type: 'TextBlock',
                      text: '{{JOB_[ID]_TITLE}}',
                      wrap: true,
                      weight: 'Bolder',
                      size: 'Medium'
                    }
                  ]
                },
                {
                  type: 'Column',
                  width: 'auto',
                  items: [
                    {
                      type: 'Image',
                      url: '{{JOB_[ID]_IMAGE_URL}}',
                      size: 'Medium',
                      altText: '{{JOB_[ID]_TITLE}}'
                    }
                  ]
                }
              ]
            },
            ...items
          ]
        },
      ],
      msTeams: {
        width: 'Full'
      }
    });
    if (jobShareType === 'linkedin-only') {
      content = generateContent([
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on LinkedIn',
              url: '{{JOB_[ID]_LINKEDIN_SHARE_LINK}}'
            }
          ]
        }
      ]);
    } else {
      content = generateContent([
        {
          type: 'TextBlock',
          text: '[[INPUT_SHARE_TEXT_TITLE]]',
          wrap: true,
          weight: 'Bolder'
        },
        {
          type: 'TextBlock',
          text: '{{JOB_[ID]_SHARE_TEXT}}',
          wrap: true,
          isSubtle: true,
          spacing: 'Small'
        },
        {
          type: 'TextBlock',
          text: '[[INPUT_SHARE_TEXT_REMINDER]]',
          wrap: true,
          isSubtle: true,
          size: 'Small',
          spacing: 'Small'
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'LinkedIn',
              url: '{{JOB_[ID]_LINKEDIN_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Facebook',
              url: '{{JOB_[ID]_FACEBOOK_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'X',
              url: '{{JOB_[ID]_TWITTER_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Messenger',
              url: '{{JOB_[ID]_MESSENGER_SHARE_LINK}}'
            },
          ]
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'WhatsApp',
              url: '{{JOB_[ID]_WHATSAPP_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Copy Share Link',
              url: '{{JOB_[ID]_COPY_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'LinkedIn Matches',
              url: '{{JOB_[ID]_MATCH_LINK}}'
            }
          ]
        }
      ]);
    }
    const attachment = {
      id,
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify(content)
    };

    return attachment;
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following jobs with your network to win rewards! ...',
      defaultValue: 'Share the following jobs with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_SHARE_TEXT_TITLE: {
      label: 'Share Text Title',
      placeholder: 'Suggested Share Text:',
      defaultValue: 'Suggested Share Text:',
      type: 'STRING'
    },
    INPUT_SHARE_TEXT_REMINDER: {
      label: 'Share Text Reminder',
      placeholder: '👆 Copy the text above to share with your network',
      defaultValue: '👆 Copy the text above to share with your network',
      type: 'STRING'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/applus/promoteJobs.js